module.exports = __webpack_public_path__ + "assets/img/block-right-hover-ffa8491c.png";